function ResponsePage() {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h1>Response Page</h1>
        <p>This is where the step-by-step explanation will appear.</p>
      </div>
    );
  }
  
  export default ResponsePage;
  